import * as React from 'react';
import {Form, Modal} from 'antd';
import {FormComponentProps} from 'antd/lib/form';

import locales from '../locales';
import {ErrorAlert} from '../common/ErrorAlert';
import {ErrorResponse} from '../api/dtos/dtos';
import InputFormItem from "../common/form-items/InputFormItem";
import furoApi from "../api/FuroApi";
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from "../app/ApplicationContext";

const FIELD_DELETE_REASON = 'deleteReason';

interface Props extends FormComponentProps {
  selectedItemIds: number[];
  onCancel: () => void;
  onConfirm: () => void;
}

interface State {
  error?: ErrorResponse;
}

class InventoryStockItemsDeleteModal extends React.Component<Props, State> {
  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: Props) {
    super(props);
    this.state = {
      error: undefined,
    };
  }

  public render(): React.ReactNode {
    const {error} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>
        <Modal
          visible={true}
          title={locales.inventory_stock_item_delete_confirm}
          okText={locales.delete}
          cancelText={locales.cancel}
          onOk={this.onOk}
          onCancel={this.props.onCancel}
        >
          <Form>
            <InputFormItem
              form={this.props.form}
              fieldId={FIELD_DELETE_REASON}
              label={locales.delete_reason}
              initialValue={undefined}
              required={true}
            />
          </Form>
          <ErrorAlert style={{marginTop: '16px'}} error={error}/>
        </Modal>
      </>
    );
  }

  private onOk = () => {
    const {selectedItemIds} = this.props;

    this.props.form.validateFields([FIELD_DELETE_REASON], (err, values) => {
      if (err) {
        return;
      }
      const value = values[FIELD_DELETE_REASON];
      const request = {
        ids: selectedItemIds,
        deletedReason: value.trim(),
      };

      const promise = furoApi.inventoryStockItems.delete(request)
        .then(this.props.onConfirm)
        .catch(this.onApiError);

      withLoadingOverlay(promise, this.loadingHandler);
    });
  };

  private onApiError = (error: ErrorResponse) => this.setState({
    error
  });
}

export default Form.create<Props>()(InventoryStockItemsDeleteModal);



// WEBPACK FOOTER //
// ./src/inventory-stock-details/InventoryStockItemsDeleteModal.tsx